import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
import { CountUp } from './CountUp';
const RADIUS = 52;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const CLOSE_RATE = 39;
export function ResponseTimeVignette() {
  const reduceMotion = useReducedMotion();
  return <VignetteFrame label="Home services client" timestamp="Measured" data-id="element-303" data-mp="m8tzge0eti3p">
      <div className="grid gap-8 sm:grid-cols-2 sm:items-center" data-id="element-304" data-mp="10yjbj4a1j6ir">
        <div data-id="element-305" data-mp="w19hfbbpi6ol">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-white/40" data-id="element-306" data-mp="vzokxg5u0do3">
            Average lead response time
          </p>

          <div className="mt-5 space-y-5" data-id="element-307" data-mp="19yerrnigdrpn">
            <div data-id="element-308" data-mp="15ynvj4a5qjdq">
              <div className="flex items-baseline justify-between gap-3" data-id="element-309" data-mp="1608qgv0dw4c4">
                <span className="text-xs font-medium text-white/50" data-id="element-310" data-mp="3brcgb7575y4s">Before</span>
                <span className="text-sm font-semibold text-white/70" data-id="element-311" data-mp="37qahusj3tq3v">4+ hours</span>
              </div>
              <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-white/[0.06]" data-id="element-312" data-mp="2r5btdhgjtu5">
                <motion.div className="h-full rounded-full bg-white/25" style={{
                willChange: 'transform',
                originX: 0
              }} initial={reduceMotion ? {
                scaleX: 1
              } : {
                scaleX: 0
              }} whileInView={{
                scaleX: 1
              }} viewport={{
                once: true,
                amount: 0.4
              }} transition={{
                duration: 0.8,
                ease: [0.22, 1, 0.36, 1]
              }} data-id="element-313" data-mp="7poy5ezyr7n1" />
              </div>
            </div>

            <div data-id="element-314" data-mp="qemvsmuhdnmk">
              <div className="flex items-baseline justify-between gap-3" data-id="element-315" data-mp="qiaqvqfkqi3e">
                <span className="text-xs font-medium text-brand" data-id="element-316" data-mp="vgc7m4pj25bp">After</span>
                <span className="text-sm font-semibold text-brand" data-id="element-317" data-mp="10dkom1yxw3bd">
                  under 10 minutes
                </span>
              </div>
              <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-white/[0.06]" data-id="element-318" data-mp="2x98tkmkz6sal">
                <motion.div className="h-full rounded-full bg-brand" style={{
                willChange: 'transform',
                originX: 0
              }} initial={reduceMotion ? {
                scaleX: 0.04
              } : {
                scaleX: 0
              }} whileInView={{
                scaleX: 0.04
              }} viewport={{
                once: true,
                amount: 0.4
              }} transition={{
                duration: 0.8,
                delay: reduceMotion ? 0 : 0.25,
                ease: [0.22, 1, 0.36, 1]
              }} data-id="element-319" data-mp="327ttsm089bz1" />
              </div>
            </div>
          </div>
        </div>

        <Reveal delay={0.15} className="flex flex-col items-center" data-id="element-320" data-mp="390qyl6liy3tn">
          <div className="relative h-32 w-32" data-id="element-321" data-mp="3mtgpnpfwtyxm">
            <svg viewBox="0 0 120 120" className="h-full w-full -rotate-90" data-id="element-322" data-mp="3hv5g7ftj1qfx">
              <circle cx="60" cy="60" r={RADIUS} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="10" data-id="element-323" data-mp="3hx82ppvh11fw" />
              <motion.circle cx="60" cy="60" r={RADIUS} fill="none" stroke="#0fb07d" strokeWidth="10" strokeLinecap="round" strokeDasharray={CIRCUMFERENCE} initial={{
              strokeDashoffset: reduceMotion ? CIRCUMFERENCE * (1 - CLOSE_RATE / 100) : CIRCUMFERENCE
            }} whileInView={{
              strokeDashoffset: CIRCUMFERENCE * (1 - CLOSE_RATE / 100)
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 1.1,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-324" data-mp="f9qm9dr648kb" />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-325" data-mp="3nn67bimwq5ta">
              <span className="font-display text-2xl font-bold text-brand" data-id="element-326" data-mp="38sruy0xulunl">
                <CountUp value={CLOSE_RATE} suffix="%" data-id="element-327" data-mp="3dprr9k4wbj1i" />
              </span>
              <span className="text-[10px] font-medium uppercase tracking-[0.1em] text-white/40" data-id="element-328" data-mp="kwvwu8ypsr3q">
                roughly
              </span>
            </div>
          </div>
          <p className="mt-4 text-center text-xs leading-relaxed text-white/50" data-id="element-329" data-mp="b6t5seb5ln81">
            Close rate on booked appointments
          </p>
        </Reveal>
      </div>
    </VignetteFrame>;
}